import { cnpj, cpf } from "cpf-cnpj-validator";

export function documentFormatter(num) {
  const onlyNumbers = num?.replace(/[^0-9]+/g, "");

  if (onlyNumbers?.length > 11) return cnpj.format(onlyNumbers);

  return cpf.format(onlyNumbers);
}

export const isCpfCnpjValid = (value) => {
  const onlyNumbers = value?.replace(/[^0-9]+/g, "");

  return onlyNumbers?.length > 12
    ? cnpj.isValid(onlyNumbers)
    : cpf.isValid(onlyNumbers);
};
